import { render, staticRenderFns } from "./BizOrder.vue?vue&type=template&id=0ca61154&lang=pug"
import script from "./BizOrder.vue?vue&type=script&lang=js"
export * from "./BizOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports